import * as React from 'react';

import './styles.scss';
import {Row, Column} from '../../layout';
import ADVLogo from '../../../assets/register/ADVLogo.svg';
import ADVLogoResponsive from '../../../assets/header/ADVLogo - header.svg';
import Icon from '../../icon';
import {Icons} from '../../../util/icons';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {
  setWizard,
  setUser,
  setBusStylesMap,
  setAvailableBus,
  setBusMap,
  setSelectedBu,
  addToUser,
} from '../../../store/actions';
import {strings} from '../../../util/strings';
import * as fonts from '../../../util/fonts';
import NonCustomerCard from './virtual-card/non-customer';
import CustomerCard from './virtual-card/customer-card';
import HeaderBackground from '../../../assets/curves/App_AdvCare_curve.svg';
import {useState, useEffect} from 'react';
import AppNavResponsive from '../../app-nav-responsive';
import _ from 'lodash';
import colors from '../../../util/colors';
import {uriCard, uriGetBus, uriGetNewCardV2} from '../../../api/endpoints';
import {get} from '../../../api/api';
import {useHistory, Link} from 'react-router-dom';
import InsertNewDataModal from './virtual-card/customer-not-found/insert-new-data-modal';
import DataNotFoundModal from './virtual-card/customer-not-found/data-not-found-modal/DataNotFoundModal';
import NewCustomerNotFoundCard from './virtual-card/customer-not-found/NewCustomerNotFoundCard';
import {ITenant} from '../../../App';
import AuthorizedImage from '../../images';

interface AppHeaderProps {
  setWizard(value: any): void;
  setUser(value: any): void;
  labels: typeof strings.pt.virtualCard;
  labelsMenu: typeof strings.pt.menu;
  buStyles: any;
  user: any;
  busFuncMap: any;
  selectedBu: any;
  setBusStylesMap(value: any): any;
  setAvailableBus(value: any): any;
  setBusMap(value: any): any;
  setSelectedBu(value: any): any;
  addToUser(value: any): any;
  hideBanner: boolean;
  busStyles: any;
  tenant: ITenant;
  updateImages: number;
  inHomePage: boolean;
}

function NewAppHeader({
  labels,
  labelsMenu,
  buStyles,
  user,
  busFuncMap,
  selectedBu,
  hideBanner,
  inHomePage,
  setUser,
  addToUser,
  setSelectedBu,
  setAvailableBus,
  setBusMap,
  setBusStylesMap,
  busStyles,
  tenant,
  updateImages,
}: AppHeaderProps) {
  const [showResponsive, setShowResponsive] = useState(false);
  const [showInserNewData, setShowInsertNewData] = useState(false);
  const [showDataNotFound, setShowDataNotFound] = useState(false);
  const history = useHistory();

  const featureName = 'NewHeader';

  const renderHeaderInfo = () => {
    if (user.state) {
      switch (user.state) {
        case 'NOTCLIENT':
          // if the user is NOT_CLIENT will display a "Need insurance" text
          return (
            <Column
              className="app-header-need-insurance-column"
              style={{...fonts.ML}}>
              {labels?.VCNeedInsurance_title}
            </Column>
          );
        case 'NOT_FOUND':
          // if the current user is NOT_FOUND and has a memId in the db it will show an error message. Otherwise it will display a info text.
          return (
            <Column
              className="app-header-functionalities-insurance-column"
              style={{
                ...fonts.ML,
                width:
                  !user.hasMemId && user.state === 'CLIENT' ? '25%' : '35%',
              }}>
              {' '}
              {user.hasMemId ? (
                <Row
                  style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: colors.alertRed,
                    alignItems: 'center',
                  }}>
                  <Icon
                    name={Icons.ALERT_PROBLEM}
                    width="40"
                    height="40"
                    viewBox="0 0 32 32"
                    changeViewbox={true}
                  />
                  <Column style={{marginLeft: '0.5rem', width: 'fit-content'}}>
                    {!!(
                      user.hasMemId && user.hasInsurenceNumberTimePassedUpdated
                    ) || user.hasNewData
                      ? labels?.VCErrorNotFound_title
                      : labels?.VCError_title}
                  </Column>
                </Row>
              ) : (
                <React.Fragment>
                  {' '}
                  <Row className="card-number-row">
                    {labels?.VCCardNumber_title}
                  </Row>{' '}
                  <a
                    className="app-header-functionalities-anchor"
                    href={labels?.VCCardNumber_link}>
                    {_.capitalize(labels?.VCCardNumber_underInputText)}{' '}
                  </a>
                </React.Fragment>
              )}{' '}
            </Column>
          );
        case 'CLIENT':
          // if the user is a CLIENT it will display the selected bu logo
          return (
            buStyles?.logo && (
              <Column className="app-header-functionalities-insurance-column">
                <Link
                  className={`app-header-bu-logo-opacity ${
                    inHomePage && 'no-pointer'
                  }`}
                  to={inHomePage ? '#' : '/inicio'}>
                  <AuthorizedImage
                    requiresAuthorization={true}
                    key={updateImages}
                    source={`${
                      process.env.REACT_APP_BASE_BACKOFFICE_IMAGES_URL
                    }${buStyles?.logo || tenant.footerImage}`}
                    className="app-header-bu-logo"
                  />
                </Link>
              </Column>
            )
          );
      }
    }
  };

  const renderHeaderCard = () => {
    if (user.state) {
      switch (user.state) {
        case 'NOTCLIENT':
          return <NonCustomerCard />;
        case 'NOT_FOUND':
          return (
            <NewCustomerNotFoundCard
              invalidData={
                !!(user.hasMemId && user.hasInsurenceNumberTimePassedUpdated) ||
                user.hasNewData
              }
              submitted={user.hasMemId}
              reSubmitted={user.hasNewData}
              onSubmit={async (values) => {
                // when the card number is inserted the same logic as in the login page will be executed
                try {
                  const userBusResponse: any = await get(
                    uriGetNewCardV2(user.nif, user.birthdate, values.cardNumber)
                  );

                  let busResponse: any;
                  busResponse = await get(uriGetBus());

                  const bus = busResponse?.data?.items;
                  const busMap: any = {};
                  userBusResponse.forEach((elem: any) => {
                    const buId = elem.buId;
                    const existingBu = !!busMap[buId];

                    const member = {...elem};
                    const memberBu = bus.find((bu: any) => bu.id === buId);
                    member.buName = (memberBu && memberBu.name) || '';

                    if (existingBu) {
                      busMap[buId].push(member);
                    } else {
                      busMap[buId] = [member];
                    }
                  });

                  let busStylesMap: any = {};
                  Object.keys(busMap).forEach(
                    (key: string, index: number) =>
                      (busStylesMap[key] = busStyles[index])
                  );
                  setBusStylesMap(busStylesMap);

                  const newSelectedBuKey = Object.keys(busMap)[0];

                  await Promise.all(
                    Object.keys(busMap).map((key) => {
                      return Promise.all(
                        busMap[key].map((member: any) => {
                          return get(
                            uriCard(member.buId, member.memId, member.famId),
                            false,
                            0,
                            featureName
                          )
                            .then((buUserCard: any) => {
                              const buUserIndex = busMap[key].indexOf(member);
                              busMap[key][buUserIndex].card = buUserCard?.data;
                            })
                            .catch((e: any) => {
                              const buUserIndex = busMap[key].indexOf(member);
                              busMap[key][buUserIndex].card = {};
                            });
                        })
                      );
                    })
                  );

                  const newSelectedBu = {...busMap[newSelectedBuKey][0]};

                  setAvailableBus(userBusResponse);
                  setBusMap(busMap);
                  setSelectedBu(newSelectedBu);
                  addToUser({state: 'CLIENT', hasMembId: true});
                  history.push('/callback');
                } catch (e: any) {
                  // if the user memId is not found it will be saved in the db and the hasMemId flag will become 'true'
                  if (e.status === 404) {
                    const newUser = {
                      ...user,
                      hasMemId: true,
                      hasInsurenceNumberTimePassedUpdated: true,
                    };
                    setUser(newUser);
                    setShowDataNotFound(true);
                  }
                }
              }}
            />
          );
        case 'CLIENT':
          return selectedBu && <CustomerCard />;
      }
    }
  };

  return showResponsive ? (
    <AppNavResponsive
      onClose={() => setShowResponsive(false)}
      busFuncMap={busFuncMap}
      selectedBu={selectedBu}
      items={
        user.state === 'CLIENT'
          ? [
              {
                label: labelsMenu.menu_start_web,
                selector: 'inicio',
                url: '/inicio',
              },
              {
                label: labelsMenu.menu_insurance_web,
                selector: 'seguro',
                url: '',
                subItems: [
                  {
                    label: labelsMenu.menu_start_subitem_utilization,
                    selector: 'historico-de-utilizacao',
                    url: '/historico-utilizacao',
                  },
                  {
                    label: labelsMenu.menu_start_subitem_myData,
                    selector: 'dados-pessoais',
                    url: '/meus-dados',
                  },
                  {
                    label: labelsMenu.menu_start_subitem_coverages,
                    selector: 'as-minhas-coberturas',
                    url: '/minhas-coberturas',
                  },
                  {
                    label: labelsMenu.menu_start_subitem_services,
                    selector: 'os-meus-servicos',
                    url: '/meus-servicos',
                  },
                  {
                    label: labelsMenu.menu_start_subitem_irs,
                    selector: 'declaracao-de-irs',
                    url: '/declaracao-irs',
                  },
                ],
              },
              {
                label: labelsMenu.menu_medicalNetwork_web,
                selector: 'rede',
                url: '/network',
              },
              {
                label: labelsMenu.menu_requests_web,
                selector: 'pedidos',
                url: '',
                subItems: [
                  {
                    label: labelsMenu.menu_start_subitem_refund,
                    selector: 'historico-de-reembolso',
                    url: '/historico-reembolsos',
                  },
                  {
                    label: labelsMenu.menu_start_subitem_preAuthorizations,
                    selector: 'pre-autorizacoes',
                    url: '/pre-autorizacoes',
                  },
                ],
              },
            ]
          : []
      }
    />
  ) : (
    <div className="app-header-container">
      <React.Fragment>
        <Row className="register-header-content app-header-background app-header-content-row">
          {renderHeaderInfo()}
          {renderHeaderCard()}

          <Column className="register-header-content-exit-column">
            <AuthorizedImage
              requiresAuthorization={false}
              source={`${
                process.env.REACT_APP_BASE_BACKOFFICE_IMAGES_URL_PUBLIC
              }${tenant?.footerImage || buStyles?.logo}`}
              onClick={() => !inHomePage && history.push('/inicio')}
              alt="ADVLogo"
              className={`app-header-logo app-header-logo-svg ${
                inHomePage && 'no-pointer'
              }`}
            />
            {showResponsive && (
              <AuthorizedImage
                requiresAuthorization={false}
                source={`${
                  process.env.REACT_APP_BASE_BACKOFFICE_IMAGES_URL_PUBLIC
                }${tenant?.footerImage || buStyles?.logo}`}
                onClick={() => !inHomePage && history.push('/inicio')}
                alt="ADVLogo"
                className={`app-header-logo app-header-logo-responsive ${
                  inHomePage && 'no-pointer'
                }`}
              />
            )}
          </Column>
          <Icon
            className="responsive-menu-button"
            width="26"
            height="26"
            name={Icons.MENU}
            onClick={() => setShowResponsive(true)}
          />
        </Row>
        {(hideBanner || window.location.pathname !== '/inicio') && (
          <img src={HeaderBackground} className="app-header-curve" />
        )}
      </React.Fragment>
      <DataNotFoundModal
        showDataNotFound={showDataNotFound}
        setShowDataNotFound={setShowDataNotFound}
        renderHeaderCard={renderHeaderCard}
      />
      <InsertNewDataModal
        show={showInserNewData}
        setShow={setShowInsertNewData}
      />
      ;
    </div>
  );
}

const mapStateToProps = ({
  strings,
  globalStyles,
  user,
  busFuncMap,
  selectedBu,
  busStyles,
  tenant,
}: any) => ({
  labels: strings.value.pt.virtualCard,
  labelsMenu: strings.value.pt.menu,
  buStyles: globalStyles.value,
  user: user.value,
  busFuncMap: busFuncMap.value,
  selectedBu: selectedBu.value.buId,
  busStyles: busStyles.value,
  tenant: tenant.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  setUser: (value: any) => dispatch(setUser(value)),
  addToUser: (value: any) => dispatch(addToUser(value)),
  setSelectedBu: (value: any) => dispatch(setSelectedBu(value)),
  setAvailableBus: (value: any) => dispatch(setAvailableBus(value)),
  setBusMap: (value: any) => dispatch(setBusMap(value)),
  setBusStylesMap: (value: any) => dispatch(setBusStylesMap(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(NewAppHeader)
);
